var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconUsers2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.9918 23.866C59.7918 23.8327 59.5585 23.8327 59.3585 23.866C54.7585 23.6994 51.0918 19.9327 51.0918 15.266C51.0918 10.4994 54.9251 6.66602 59.6918 6.66602C64.4585 6.66602 68.2918 10.5327 68.2918 15.266C68.2584 19.9327 64.5918 23.6994 59.9918 23.866Z",
    stroke: "#1E729F",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.558 48.1332C61.1247 48.8999 66.158 48.0999 69.6914 45.7332C74.3914 42.5999 74.3914 37.4666 69.6914 34.3332C66.1247 31.9666 61.0247 31.1665 56.458 31.9665",
    stroke: "#1E729F",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8918 23.866C20.0918 23.8327 20.3251 23.8327 20.5251 23.866C25.1251 23.6994 28.7918 19.9327 28.7918 15.266C28.7918 10.4994 24.9585 6.66602 20.1918 6.66602C15.4251 6.66602 11.5918 10.5327 11.5918 15.266C11.6251 19.9327 15.2918 23.6994 19.8918 23.866Z",
    stroke: "#1E729F",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3253 48.1332C18.7587 48.8999 13.7253 48.0999 10.192 45.7332C5.49199 42.5999 5.49199 37.4666 10.192 34.3332C13.7587 31.9666 18.8587 31.1665 23.4253 31.9665",
    stroke: "#1E729F",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0006 48.7664C39.8006 48.7331 39.5673 48.7331 39.3673 48.7664C34.7673 48.5998 31.1006 44.8331 31.1006 40.1664C31.1006 35.3997 34.9339 31.5664 39.7006 31.5664C44.4672 31.5664 48.3006 35.4331 48.3006 40.1664C48.2673 44.8331 44.6006 48.6331 40.0006 48.7664Z",
    stroke: "#1E729F",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3004 59.2672C25.6004 62.4005 25.6004 67.5338 30.3004 70.6672C35.6337 74.2338 44.3671 74.2338 49.7004 70.6672C54.4004 67.5338 54.4004 62.4005 49.7004 59.2672C44.4004 55.7339 35.6337 55.7339 30.3004 59.2672Z",
    stroke: "#1E729F",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUsers2);
export default __webpack_public_path__ + "static/media/iconUsers2.27bf9eef51daf8530f5cf52fdbda485e.svg";
export { ForwardRef as ReactComponent };